import { getInfo } from "@/api/user_center";
import { isEmpty } from "lodash-es";

const state = {
  userInfo: undefined,
};

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
};

const actions = {
  async getUserInfo({ commit, state }) {
    if (state.userInfo) return state.userInfo;
    const resp = await getInfo();
    if (!isEmpty(resp)) {
      commit("SET_USER_INFO", resp);
      return resp;
    } else {
      commit("SET_USER_INFO", undefined);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
